'use es6';

import { jsx as _jsx } from "react/jsx-runtime";

let _ = t => t,
    _t,
    _t2,
    _t3;

import styled from 'styled-components';
import breakpoint from 'pricing-pages-unified-ui/utils/responsiveBreakpoints';
import { GREAT_WHITE, OLAF } from 'HubStyleTokens/colors';
export const borderStyle = `1px solid ${GREAT_WHITE}`;
export const Section = styled.div.withConfig({
  displayName: "MerchCardSharedComponents__Section",
  componentId: "fjwmir-0"
})(["", ""], breakpoint.tablet(_t || (_t = _`
    border-right: ${0};
    border-bottom: ${0};
  `), ({
  isMon569Variant
}) => isMon569Variant ? `none !important` : undefined, ({
  isMon569Variant,
  showBorderBottom
}) => isMon569Variant && showBorderBottom ? borderStyle : undefined));
export const FillerRow = ({
  row,
  commonStyles
}) => /*#__PURE__*/_jsx("div", {
  style: Object.assign({
    msGridRow: row,
    gridRowStart: row
  }, commonStyles)
});
/* stylelint-disable property-no-vendor-prefix */

export const StyledCardGrid = styled.div.withConfig({
  displayName: "MerchCardSharedComponents__StyledCardGrid",
  componentId: "fjwmir-1"
})(["display:-ms-grid;display:grid;grid-template-columns:repeat( ", ",calc(100% / ", ") );-ms-grid-columns:(calc(100% / ", ")) [ ", "];border:", ";background:", ";max-width:", ";width:100%;border-radius:3px;", ";", ";"], props => props.columns, props => props.columns, props => props.columns, props => props.columns, borderStyle, OLAF, props => props.columns < props.maxColumns ? 'calc(100% / 3 * 2)' : 'initial', breakpoint.tablet(_t2 || (_t2 = _`
    max-width: initial;
    width: 80% !important;
    margin-top: 20px;
  `)), breakpoint.phone(_t3 || (_t3 = _`
    max-width: initial;
    width: 90% !important;
  `)));